import { render, staticRenderFns } from "./IlEkle.vue?vue&type=template&id=4eb46af8&scoped=true&"
import script from "./IlEkle.vue?vue&type=script&lang=js&"
export * from "./IlEkle.vue?vue&type=script&lang=js&"
import style0 from "./IlEkle.vue?vue&type=style&index=0&id=4eb46af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb46af8",
  null
  
)

export default component.exports